"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
require("./SelectableSetting.css");
function SelectableSetting({ selected, disabled, className, onToggle, onDeselect, onSelect, children, }) {
    function onClick() {
        if (!disabled) {
            onToggle && onToggle(!selected);
            selected && onDeselect && onDeselect();
            !selected && onSelect && onSelect();
        }
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: "selectable-setting", className: (0, clsx_1.default)(className, {
            selected,
            disabled,
        }), onClick: onClick }, { children: children })));
}
exports.default = SelectableSetting;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VsZWN0YWJsZVNldHRpbmcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wcm9qZWN0L2Z1bGxtYXAvbW9kYWxzL1NlbGVjdGFibGVTZXR0aW5nLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxnREFBd0I7QUFFeEIsbUNBQWlDO0FBV2pDLFNBQXdCLGlCQUFpQixDQUFDLEVBQ3hDLFFBQVEsRUFDUixRQUFRLEVBQ1IsU0FBUyxFQUNULFFBQVEsRUFDUixVQUFVLEVBQ1YsUUFBUSxFQUNSLFFBQVEsR0FDZTtJQUN2QixTQUFTLE9BQU87UUFDZCxJQUFJLENBQUMsUUFBUSxFQUFFO1lBQ2IsUUFBUSxJQUFJLFFBQVEsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1lBQ2hDLFFBQVEsSUFBSSxVQUFVLElBQUksVUFBVSxFQUFFLENBQUM7WUFDdkMsQ0FBQyxRQUFRLElBQUksUUFBUSxJQUFJLFFBQVEsRUFBRSxDQUFDO1NBQ3JDO0lBQ0gsQ0FBQztJQUVELE9BQU8sQ0FDTCw4Q0FDRSxFQUFFLEVBQUMsb0JBQW9CLEVBQ3ZCLFNBQVMsRUFBRSxJQUFBLGNBQUksRUFBQyxTQUFTLEVBQUU7WUFDekIsUUFBUTtZQUNSLFFBQVE7U0FDVCxDQUFDLEVBQ0YsT0FBTyxFQUFFLE9BQU8sZ0JBRWYsUUFBUSxJQUNMLENBQ1AsQ0FBQztBQUNKLENBQUM7QUE3QkQsb0NBNkJDIn0=